import React from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, BookOpen, Brain, Zap } from 'lucide-react';
export function ProductPromise() {
  const cards = [{
    icon: Stethoscope,
    emoji: '🩺',
    title: 'Procedimientos organizados',
    desc: 'Cada técnica clínica explicada paso a paso para que sepas exactamente qué hacer.'
  }, {
    icon: BookOpen,
    emoji: '📚',
    title: 'Protocolos y farmacología',
    desc: 'Pautas clínicas, cálculos, dosis y red flags ordenados en un solo lugar.'
  }, {
    icon: Brain,
    emoji: '🧠',
    title: 'Casos clínicos aplicados',
    desc: 'Aprendé a pensar como enfermería clínica real con casos resueltos paso a paso.'
  }, {
    icon: Zap,
    emoji: '⚡',
    title: 'Material para práctica real',
    desc: 'Diseñado para parciales, internado y los momentos que más importan en el hospital.'
  }];
  return <section className="relative py-12 md:py-20 lg:py-24 bg-white overflow-hidden" data-id="element-406">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[40rem] bg-clinical-softer rounded-full blur-[140px] opacity-50 pointer-events-none" data-id="element-407"></div>

      <div className="relative max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-408">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14" data-id="element-409">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-4" data-id="element-410">
            Más que un pack
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl sm:text-4xl md:text-5xl font-black text-clinical-deep mb-4 leading-[1.05] uppercase" data-id="element-411">
            No es solo un{' '}
            <span className="accent-italic normal-case" data-id="element-412">pack de apuntes</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-sm md:text-lg text-clinical-ink leading-relaxed" data-id="element-413">
            Es un sistema clínico pensado para ayudarte a{' '}
            <span className="accent-italic" data-id="element-414">
              relacionar teoría con práctica real
            </span>{' '}
            y estudiar con mucha más claridad y seguridad.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-id="element-415">
          {cards.map((card, idx) => {
          const Icon = card.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.08
          }} className="group relative bg-clinical-base rounded-2xl p-5 md:p-6 border border-clinical-line hover:border-clinical-mid/40 hover:-translate-y-1 transition-all overflow-hidden" data-id="element-416">
                <div className="absolute top-0 right-0 w-24 h-24 bg-clinical-softer rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-417"></div>

                <div className="relative" data-id="element-418">
                  <div className="w-11 h-11 rounded-xl bg-white border border-clinical-line flex items-center justify-center mb-4 shadow-sm" data-id="element-419">
                    <Icon className="w-5 h-5 text-clinical-mid" strokeWidth={2} data-id="element-420" />
                  </div>

                  <h3 className="text-base md:text-lg font-bold text-clinical-deep mb-2 leading-snug" data-id="element-421">
                    {card.title}
                  </h3>

                  <p className="text-sm text-clinical-ink/80 leading-relaxed" data-id="element-422">
                    {card.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}